import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
})

export default class TechBetterCorpCoZaHome extends Vue {
  public readonly ParallaxLogos = [
    // 'BETTERCORP',
    'TECH',
    'COMPUTER',
    'SUPPORT',
    'TECH',
    'RMM',
    'MANAGED',
  ];
}
